import CmDeliveryNoteNumber from './CmDeliveryNoteNumber';
import Comment from './Comment';
import Created from './Created';
import CreatorUser from './CreatorUser';
import Customer from './Customer';
import CompletedDate from './DeliveryDate';
import GrossPrice from './GrossPrice';
import Id from './Id';
import Invoice from './Invoice';
import IsBillable from './IsBillable';
import IsStockist from './IsStockist';
import NetPrice from './NetPrice';
import ReceiptNumber from './ReceiptNumber';
import Status from './Status';
import Storage from './Storage';
import Supplier from './Supplier';
import Updated from './Updated';

export const compareTypes = {
  net_price: 'number',
  gross_price: 'number',
};

export const labels = {
  Id: 'Id',
  ReceiptNumber: 'Bizonylatszám',
  CmDeliveryNoteNumber: 'CM szlev száma',
  Status: 'Státusz',
  Supplier: 'Szállító',
  Comment: 'Megjegyzés',
  Customer: 'Átvevő',
  IsStockist: 'Besz. ár végleges',
  Storage: 'Raktár',
  CompletedDate: 'Teljesítés dátuma',
  CreatorUser: 'Rögzítette',
  NetPrice: 'Nettó ár',
  GrossPrice: 'Bruttó ár',
  IsBillable: 'Számlázandó',
  Invoice: 'Számla',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'Invoice',
}, {
  value: 'Supplier',
}, {
  value: 'Customer',
}, {
  value: 'Storage',
}, {
  value: 'IsStockist',
}, {
  value: 'CompletedDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'Comment',
}, {
  value: 'GrossPrice',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Status',
}, {
  value: 'IsBillable',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'Status',
}, {
  value: 'Invoice',
}, {
  value: 'Supplier',
}, {
  value: 'CompletedDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'IsBillable',
}, {
  value: 'IsStockist',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  ReceiptNumber,
  CmDeliveryNoteNumber,
  Status,
  Customer,
  Supplier,
  Storage,
  CompletedDate,
  CreatorUser,
  NetPrice,
  GrossPrice,
  Created,
  Updated,
  IsBillable,
  IsStockist,
  Comment,
  Invoice,
};
